module.exports = __webpack_public_path__ + "img/joveilica.25c215ca.png";